import request from "@/CommonDP/utils/request";
export default {
// CommonDP/components/commonComponents 组件测试
  getDicList(dicCode) {
    return request.get(`/dic/content/list?dicCode=${dicCode}`, { title: "字典数据请求中..." });
  },
  // 控件字典
  queryDicContentByName(dicCode = "CONTROL") {
    return request.get(`/dic/content/queryDicContentByName?dicCode=${dicCode}`).then((res) => res);
  }
};
